import { Card } from "@blueprintjs/core";
import { useSetPlatformBreadcrumbs } from "infrastructure/platform/PlatformShellContext";
import React, { useEffect } from "react";
import "./HomeView.scss";
import RegionSelectorCard from "./regionSelector/RegionSelectorCard";

const HomeView: React.FC = () => {
    const setBreadcrumbs = useSetPlatformBreadcrumbs();
    useEffect(() => {
        setBreadcrumbs([{ text: "Home", current: true }]);
        return () => setBreadcrumbs([]);
    }, [setBreadcrumbs]);

    return (
        <div className="HomeView-wrapper">
            <Card className="HomeView-card" elevation={1}>
                <RegionSelectorCard />
            </Card>
        </div>
    );
};

export default HomeView;
